import React, { useEffect, useState, useCallback } from 'react';
import SkeletonLoader from './components/AgendaContent/SkeletonLoader';
import Filter from './Filter';

import { today, dbDateToTimestamp } from './utils/helpers';

const App = ({ config, rootElement }) => {
	//state reflecting data and filtered data
	const [eventFeed, setEventFeed] = useState(null); //source data
	const [promoData, setPromoData] = useState(null); //promo source data
	const [bundleData, setBundleData] = useState(null); //bundle source data
	const [fetching, setFetching] = useState(true);

	//params available in dropdown for filter
	const availableTabs = config.available_tabs;
	const [availableLocations, setAvailableLocations] = useState([]);
	const [availableDates, setAvailableDates] = useState([]);
	const [availableTags, setAvailableTags] = useState([]); //genres
	const [availableCategories, setAvailableCategories] = useState([]); //"ontdekken"/discover

	/**
	 * @description   Fetching feed
	 */
	async function fetchData() {
		const lang = rootElement.dataset.lang;
		
		let fetch_url = customData.homeUrl + '/event_feed_json/';

		if (lang === 'en') {
			fetch_url = customData.homeUrl + '/en/event_feed_json/';
		}

		const response = await fetch(fetch_url);

		if (!response.ok) {
			const message = `An error has occured: ${response.status}`;
			throw new Error(message);
		}
		const data = await response.json();
		return data;
	}

	/**
	 * @description   Retrieves available parameters for filtering from the feed + sets the state
	 *                And adds a js date to the feed data
	 */
	const parseEventData = useCallback(
		(data) => {
			const dataCopy = structuredClone(data); //kopie van data
			const allShowDays = [today];
			let daysCount = 1;
			let subsequentDay = new Date();
			while (config.minimum_days_in_filter && daysCount <= config.minimum_days_in_filter) {
				subsequentDay.setDate(subsequentDay.getDate() + 1);
				allShowDays.push(+new Date(subsequentDay.getFullYear(), subsequentDay.getMonth(), subsequentDay.getDate()));
				daysCount++;
			}
			const allLocations = [];
			const allTags = [];
			const allCategories = [];
			const parsedData = [];
			// const allPrices = [];

			Object.values(dataCopy).forEach((event) => {
				if (event?.times && event.times.length > 0) {
					event.times.map((show) => {
						if (show?.location) {
							!allLocations.some((location) => Object.keys(location)[0] === Object.keys(show.location)[0]) && allLocations.push(show.location);
						}

						const timestamp = dbDateToTimestamp(show.program_start);
						allShowDays.indexOf(timestamp) === -1 && allShowDays.push(timestamp);
						show.date = timestamp;
						return show;
					});
				}

				if (event?.tags && Object.keys(event.tags).length > 0) {
					Object.keys(event.tags).forEach((slug) => {
						!allTags.some((tag) => Object.keys(tag)[0] === slug) && allTags.push({ [slug]: event.tags[slug], category: Object.values(event?.main_genre)[0] });
					});
				}
				const main_genre = Object.values(event?.main_genre)[0];
				if (main_genre && typeof main_genre === 'string' && main_genre.trim().length > 0) {
					const genre = main_genre.trim();
					if (!allCategories.some((category) => Object.keys(category)[0] === genre)) {
						allCategories.push({ [genre]: genre });
					}
				}
				parsedData.push(event);
			});

			setAvailableLocations(allLocations);
			setAvailableDates(allShowDays.sort((a, b) => a - b));
			setAvailableTags(allTags);
			setAvailableCategories(allCategories);

			return parsedData;
		},
		[config]
	);

	const parseBundleData = useCallback((data) => {
		const allTags = [];
		const allCategories = [];
		const parsedBundles = [];

		Object.values(data).forEach((bundle) => {
			if (bundle?.tags && Object.keys(bundle.tags).length > 0) {
				Object.keys(bundle.tags).forEach((slug) => {
					if (!allTags.some((tag) => Object.keys(tag)[0] === slug)) {
						allTags.push({ [slug]: bundle.tags[slug], category: Object.values(bundle?.main_genre)[0] });
					}
				});
			}

			const main_genre = Object.values(bundle?.main_genre)[0];
			if (main_genre && typeof main_genre === 'string' && main_genre.trim().length > 0) {
				const genre = main_genre.trim();
				if (!allCategories.some((category) => Object.keys(category)[0] === genre)) {
					allCategories.push({ [genre]: genre });
				}
			}

			parsedBundles.push(bundle);
		});

		setAvailableTags((prevTags) => [...prevTags, ...allTags.map((tag) => ({ ...tag, source: 'bundle' }))]);

		setAvailableCategories((prevCategories) => [...prevCategories, ...allCategories.map((category) => ({ ...category, source: 'bundle' }))]);

		return parsedBundles;
	}, []);

	useEffect(() => {
		fetchData().then((data) => {
			setEventFeed(parseEventData(data.events));
			setPromoData(data.promos);
			setBundleData(parseBundleData(data.bundles)); // Process bundles
			setFetching(false);
		});
	}, []);

	if (fetching)
		return (
			<div className="loader__container--agenda">
				<SkeletonLoader pageSize={config.pagination_pagesize} />
			</div>
		);

	return (
		<Filter
			config={config}
			eventFeed={eventFeed}
			promoData={promoData}
			bundleData={bundleData}
			availableLocations={availableLocations}
			availableTabs={availableTabs}
			availableDates={availableDates}
			availableTags={availableTags}
			availableCategories={availableCategories}
			rootElement={rootElement}
			// availablePrices={availablePrices}
		/>
	);
};

export default App;
